import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BuildingType } from '../../data';

@Component({
    selector: '[app-totalizer-roof]',
    templateUrl: './totalizer-roof.component.html',
    styleUrl: './totalizer-roof.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TotalizerRoofComponent {
  type = input<BuildingType>();
}
